import React, { useEffect, useState, } from 'react'
import { Helmet, } from "react-helmet"
import Loading from '../layouts/Loading'
import { appName, appDescription, } from '../../constants'
import GetStartedComponent from './GetStartedComponent'

import joystickBedroomSoloPlayPhoto from '../../assets/images/about/joystick-bedroom-solo-play.jpeg'
import joystickBedroomGroupPlayPhoto from '../../assets/images/about/joystick-lounge-group-play.jpeg'

import "./AboutComponent.scss"

export default function AboutComponent() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
    if (540 > window.innerWidth) {
      document.getElementsByClassName("about-container")[0]
        .classList
        .add("about-mobile-margin-top")
    }
  }, [])

  if (loading) {
    return <div className='about-container'>
      <Helmet>
        <title>About - {appName}</title>
        <meta name="title" content={`About - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <div className="container text-center mt-9 mb-8">
        <Loading />
      </div>
    </div>
  }

  return (
    <div className='about-container'>
      <Helmet>
        <title>About - {appName}</title>
        <meta name="title" content={`About - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <section id="product" className="py-7 py-lg-10 py-sm-10">
        <div className="container">
          <div className="row mb-4">
            <div className="col-md-6 h-100 text-center text-md-start p-0 p-md-5 pb-3">
              <h2 className="mt-3">About Joystick</h2>
              <p className="mb-0">
                We created JOYSTICK to change how players engage with
                games, with each other, and with progression itself. At its core,
                JOYSTICK is software that powers real-time, skill-based
                challenges, custom gameplay mechanics, and player-driven
                outcomes across multiple game experiences.
              </p>
            </div>
            <div className="col-md-6">
              <div className="w-100 h-100 p-5 services-card-shadow rounded-4"><img src="/assets/img/icons/1.png" alt="Dashboard" style={{ width: "95px" }}/>
                <h3 className="mt-3 lh-base">What Joystick Does</h3>
                <p className="mb-0">
                  JOYSTICK is a modular gameplay engine and engagement
                  layer that sits on top of your favourite games. 
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="w-100 h-100 p-5 services-card-shadow rounded-4"><img src="/assets/img/icons/2.png" alt="Comment" style={{ width: "95px" }}/>
                <h3 className="mt-3 lh-base">🕹️ Skill-Based Challenges</h3>
                <p className="mb-0">
                  Players compete using measurable in-game actions —
                  accuracy, speed, movement, reaction time, decision-making —
                  rather than luck or random outcomes.
                  Every match, challenge, or encounter is resolved by player
                  performance, not RNG.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="w-100 h-100 p-5 services-card-shadow rounded-4"><img src="/assets/img/icons/3.png" alt="Tailored" style={{ width: "95px" }}/>
                <h3 className="mt-3 lh-base">Real-Time Competitive Logic</h3>
                <p className="mb-0">
                  JOYSTICK software runs real-time logic that tracks:
                  <ul>
                    <li>Player actions</li>
                    <li>Match events</li>
                    <li>Outcomes</li>
                    <li>Progression triggers</li>
                  </ul>
                  This allows developers to create dynamic challenges, live
                  events, and competitive formats without relying on external
                  systems or third-party solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="customers">
        <div className="container">
          <h1 className="text-center display-5 fw-semi-bold" data-zanim-xs='{"delay":0.3}' data-zanim-trigger="scroll">Why Joystick Exists</h1>
          <p className="text-center fs-0 fs-md-1" data-zanim-xs='{"delay":0.5}' data-zanim-trigger="scroll">
            Modern games are flooded with:
            <br/>
            • Loot boxes
            • Artificial progression
            • Monetisation over gameplay
            <br/>
            JOYSTICK was built as an alternative.
            <br/>
            We believe:
            <br/>
            • Skill should matter
            • Competition should be fair
            • Progression should feel earned
            • Players should feel in control
          </p>
          <div className="row mb-4 mt-6">
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/4.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Trend</h4>
              <p className="fs-0">Oversee your trend history.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/5.png" alt="Comment" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Real World Value</h4>
              <p className="fs-0">Your winnings will go further than ever before.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/6.png" alt="Tailored" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Complete Games</h4>
              <p className="fs-0">Create your own playtime history.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/7.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Social Influence</h4>
              <p className="fs-0">Become better at the games you love.</p>
            </div>
          </div>
          <div className="row mb-6">
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/8.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Activity Notifications</h4>
              <p className="fs-0">Display your recent games and current games resources and win more.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/9.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Custom Journeys</h4>
              <p className="fs-0">Take your journey with ease and comfort of different level.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/10.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Leisurely Playing</h4>
              <p className="fs-0">Control how and when you play.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/11.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Fast Interfaces</h4>
              <p className="fs-0">Have dedicated digital platforms that you can depend on.</p>
            </div>
          </div>
          <div className="row mb-6">
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/12.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Visitor Identification</h4>
              <p className="fs-0">Verify your identity in accordance with laws then play your way.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/13.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Your Rules</h4>
              <p className="fs-0">Manage the playing data you care about.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/14.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Mobile Optimized</h4>
              <p className="fs-0">The Joystick mobile app is readily available on iOS and Android.</p>
            </div>
            <div className="col-md-6 col-lg-3 text-center"><img src="/assets/img/icons/15.png" alt="Dashboard" style={{ width: "95px" }}/>
              <h4 className="mt-3 lh-base">Fly High</h4>
              <p className="fs-0">Translate recent activity notifications into better games.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing">
        <div className="container">
          <div className="row flex-center">
            <div className="col-md-6 text-center text-md-start">
              <h4 className="fw-normal fs-3" data-zanim-xs='{"delay":0.3}' data-zanim-trigger="scroll">Built for Players & Developers</h4>
              <p className="fs-0 pe-xl-8" data-zanim-xs='{"delay":0.5}' data-zanim-trigger="scroll">JOYSTICK is designed to be:</p>
              <div className="d-flex justify-content-space-between align-item-center my-3 mt-2">
                <div>
                  <h4 className="fw-normal fs-1">✅ Player-First</h4>
                  <p className="my-1 fs-0 pe-xl-8">
                    <ul>
                      <li>Transparent systems</li>
                      <li>Clear outcomes</li>
                      <li>No hidden mechanics</li>
                      <li>No unfair advantages</li>
                    </ul>
                  </p>
                </div>
                <div>
                  <h4 className="fw-normal fs-1">🖥️ Developer-Friendly</h4>
                  <p className="my-1 fs-0 pe-xl-8">
                    <ul>
                      <li>Modular integration</li>
                      <li>Flexible design logic</li>
                      <li>Adaptable across genres</li>
                      <li>Built to scale</li>
                    </ul>
                  </p>
                </div>
              </div>
              <a href="/user/register" className="btn btn-sm joystick-btn my-4 me-1" role="button">
                Get started
              </a>
              {/* <a className="btn btn-sm my-2 btn-default" href="#" role="button">
                Questions? Talk to our team<i className="fas fa-arrow-right ms-2"></i>
              </a> */}
            </div>
            <div className="col-md-6 mb-4"><img className="w-100 rounded-about-photo" src={joystickBedroomGroupPlayPhoto} alt="..." /></div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4"><img className="w-100 rounded-about-photo" src={joystickBedroomSoloPlayPhoto} alt="..." /></div>
            <div className="col-md-6 text-center text-md-start">
              <h4 className="fs-3 fw-normal" data-zanim-xs='{"delay":0.3}' data-zanim-trigger="scroll">Play the way you want, <br />And oversee it all</h4>
              <p className="fs-0 pe-xl-7" data-zanim-xs='{"delay":0.5}' data-zanim-trigger="scroll">
                From fast-paced arena games to creative competitive worlds,
                JOYSTICK adapts to the vision — not the other way around.
              </p>
              <div className="d-flex justify-content-center align-item-center my-3 mt-2">
                <div>
                  <h4 className="fw-normal fs-1">THE JOYSTICK UNIVERSE</h4>
                  <p className="my-1 fs-0 pe-xl-8">
                    Los Muertos is the first world built using JOYSTICK's core
                    technology — a stylised, competitive universe where:
                    <ul>
                      <li>Players build their weapons</li>
                      <li>Skulls represent victory and risk</li>
                      <li>Every encounter has consequences</li>
                      <li>Skill determines survival</li>
                    </ul>
                    But it's only the beginning.
                    JOYSTICK is a platform, not a single game.
                  </p>
                </div>
                {/* <div>
                  <h4 className="fw-normal fs-1">Share</h4>
                  <p className="my-1 fs-0 pe-xl-8">Your caring gets it's way. Let your people know.</p>
                </div> */}
              </div>
              <a href="/user/register" className="btn btn-sm joystick-btn btn-bg-purple my-4 me-1" role="button">
                Get started
              </a>
              {/* <a className="btn btn-sm my-2 btn-default" href="#" role="button">
                Questions? Talk to our team<i className="fas fa-arrow-right ms-2"></i>
              </a> */}
            </div>
          </div>
        </div>
      </section>

      <section className="p-0" id="docs">
        <div
          className="bg-holder d-none d-lg-block"
          style={{
            backgroundImage: "url(/assets/img/joystick/about/joystick-lounge-couple-play.jpeg)",
            backgroundPosition: "right top",
            backgroundSize: "contain"
          }}
        ></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-7 col-xl-5 text-lg-start text-center">
              <h1 className="fs-3 fw-normal mt-6">Our Mission</h1>
              <p className="fs-0">
                To build a future where games are:
                <ul>
                  <li>More competitive</li>
                  <li>More creative</li>
                  <li>More rewarding</li>
                  <li>More human</li>
                </ul>
                JOYSTICK exists to give power back to players — and better
                tools to creators.
                Welcome to the new frontier of play.
              </p>
            </div>
          </div>
          <div className="row align-items-center mt-7">
            <h4 className="fs-2 fw-normal">Save Time</h4>
            <ul className="list-unstyled py-3">
              <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Intuitive gaming and single interface</li>
              <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Online and digital</li>
              <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Real-time notifications</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container" id="auto">
          <div className="row align-items-center">
            <div className="col-md-6 text-md-start">
              <h4 className="fs-2 fw-normal">Monitor your expenses</h4>
              <ul className="list-unstyled py-3">
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Specific games resources you've purchased</li>
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>A digital platform to oversee your playtime</li>
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Start playing to follow-up on your expenses</li>
              </ul>
            </div>
            <div className="col-md-6 mt-4 mt-md-0 text-start">
              <h4 className="fs-2 fw-normal">Make playing easier</h4>
              <ul className="list-unstyled py-3">
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Manage your play history</li>
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Manage your purchases</li>
                <li className="mb-3 text-900"><span className="far fa-check-circle text-700 me-2"></span>Our mobile app and dashboard have management tools</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <GetStartedComponent/>
    </div>
  )
}
